import type { CSSProperties, ReactElement } from 'react'

import { Flex, Icon } from 'components/core'
import { IconListType } from 'components/core/Icon/constants'
import { CountryCode } from 'types'

import * as styles from './styles.module.scss'

interface FlagProps {
    country: CountryCode
    width?: number
    height?: number
    borderRadius?: number
}

const Flag = ({
    country,
    width = 20,
    height = 15,
    borderRadius,
}: FlagProps): ReactElement => {
    const countryUpperCase = country?.toUpperCase()
    const frameStyle: CSSProperties = {
        width,
        height,
        borderRadius: borderRadius ? `${borderRadius}px` : undefined,
    }
    return (
        <Flex
            className={styles.flagWrapper}
            style={frameStyle}
            data-testid={countryUpperCase}
        >
            <Icon
                name={countryUpperCase as IconListType}
                height={height}
                width={width}
            />
        </Flex>
    )
}

export default Flag
